import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const ITR_UTM_REF = 'itr_2023_organic_landing_page_2';
const startFilingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing?utm_ref=${ITR_UTM_REF}`;
export const startFilingLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
export const cryptoIntegrationLink = `${publicRuntimeConfig.SSO_ENDPOINT}?product=crypto&utm_ref=crypto_itr_2_integration_page&return_path=L2NyeXB0by10YXgtZmlsaW5nL2Jyb2tlcnMv`;

const heroSection = {
  title: 'File ITR for capital gains in minutes ',
  lists: [
    'Stocks, Mutual Funds, ESOPs & RSUs',
    'Land, Foreign Income, US Stocks & NRI',
    'Crypto, NFTs, DeFi',
  ],
  button: [
    {
      text: 'Start filing',
      url: startFilingLink,
    },
    {
      text: 'View plans',
    },
  ],
};

const whyChooseSection = {
  title: 'Why choose ClearTax',
  lists: [
    {
      title: 'Set off losses in 3 simple steps',
      desc: 'Auto-adjust multiple years’ losses in seconds to save taxes',
    },
    {
      title: 'Complex calculations done in seconds',
      desc: 'Dump the guesswork. We’ll do the math for you',
    },
    {
      title: 'Easy reporting of foreign income',
      desc: 'Claim your foreign tax credits in just a few clicks',
    },
    {
      title: 'Simplified crypto tax filing',
      desc: 'India’s only end-to-end crypto tax filing platform',
    },
  ],
  buttons: [
    {
      text: 'Start FIling',
      url: startFilingLink,
    },
  ],
};
export const ExchangeList = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/718342aa-8b15-49d5-9d1a-45d1806e5c1e.png',
    name: 'Upstox',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/db2e54bb-de91-464e-8814-060c807fc7c3.png',
    name: 'Kite',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/3bc8bfe5-ea83-404c-b41e-8f5ea8d633e8.png',
    name: 'Groww',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4b73f019-0e78-4e20-a1c8-4b0798130b54.png',
    name: 'ICICI Direct',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/e8ce47b3-1f4c-48c8-aece-129ab4c098ff.png',
    name: 'Paytm Money',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/bb34b676-c260-4564-8789-353fa5cb6237.png',
    name: 'SBI Caps',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/1a4f9afc-2d8e-4289-9190-04eed9f7a244.png',
    name: 'Kotak',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/a965c566-85b4-4d76-b10a-687be311c652.png',
    name: 'Axis Securities',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/734b28d5-91cf-4d68-8382-82209468c896.png',
    name: 'Reliance Securities',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d37ab44c-70e2-493b-8bbc-eed9dcc53534.png',
    name: 'Zerodha',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/5937fd37-48df-404b-be2e-ed89f99e3a12.png',
    name: 'HDFC Securities',
  },
];

export const ExchangeList2 = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108712_wazirx_logo.png',
    name: 'WazirX',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109419_coindcx_logo.png',
    name: 'CoinDCX',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/taxengine-crypto/images/1682491670_coinswitch.svg',
    name: 'CoinSwitch',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109376_binance_logo.png',
    name: 'Binance',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109827_coinbase_logo.png',
    name: 'Coinbase',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109384_bitbns_logo.png',
    name: 'BitBNS',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108721_zebpay__logo.png',
    name: 'Zebpay',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108642_metamask_logo.png',
    name: 'Metamask',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109568_etherium_logo.png',
    name: 'Etherium',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
];

export const itrData = {
  heroSection,
  isVariant: false,
  whyChooseSection,
};

export const GuidesAndLinksDataITR2 = {
  heading: 'Guides and useful links to help you Efile taxes',
  cards: [
    {
      label: 'Income tax filing for capital gains ',
      description: `File your ITR-2 on Cleartax in just a few steps. We’ve made tax filing super easy for you.
`,
      link: 'https://cleartax.in/s/itr2',
    },
    {
      label: 'Types of capital gains income',
      description: `Tax implications on capital gains income, types, exemption, and tax savings`,
      link: 'https://cleartax.in/s/capital-gains-income',
    },
    {
      label: 'Set off & carry forward capital losses',
      description: `Calculate your capital gains tax as per the tax rate applicable and understand how capital losses are treated`,
      link: 'https://cleartax.in/s/set-off-carry-forward-capital-losses',
    },
    {
      label: 'Tax implications on mutual funds',
      description: `Before investing in mutual funds, understand how your returns will be taxed. Also, get tax deductions in certain cases.`,
      link: 'https://cleartax.in/s/different-mutual-funds-taxed',
    },
    {
      label: 'Capital gains tax on property/jewellery sale',
      description: `desA guide to understanding how gains or losses from the sale of property, shares, or gold will be taxed under the head ‘Capital Gains’ccccc`,
      link: 'https://cleartax.in/s/capital-gain-tax-on-sale-of-property-shares-gold',
    },
    {
      label: 'Taxability on the sale of agricultural land',
      description: `A guide to understanding how gains or losses from the sale of property, shares, or gold will be taxed under the head ‘Capital Gains’`,
      link: 'https://cleartax.in/s/capital-gains-exemption-on-sale-of-agricultural-land',
    },
    {
      label: 'Guide to crypto taxes in India 2023',
      description: `Everything you need to know about how cryptocurrencies in India are taxed. Know if crypto is a currency or an asset.`,
      link: 'https://cleartax.in/s/cryptocurrency-taxation-guide',
    },
    {
      label: 'LTCG calculator',
      description: `Calculate your long-term capital gains based on the holding period of equity-oriented mutual funds and listed equity shares.`,
      link: 'https://cleartax.in/s/ltcg-calculator',
    },
  ],
};

export const ITR_2_FAQs = [
  {
    header:
      'Can I set off my short-term capital loss against any other head of income?',
    content: (
      <>
        <p>
          Capital losses can be set off only against capital gains. Accordingly,
          short-term capital losses can be set off against any income under
          capital gains, be it short-term or long-term. However, long-term
          capital losses can be set off only against long-term capital gains.
        </p>
      </>
    ),
  },
  {
    header:
      'Is the benefit of indexation available on gains from the sale of a short-term capital asset?',
    content: (
      <p>
        Capital gains are calculated by subtracting the purchase price from the
        sale price. However, for an asset that has been held for a long period,
        determining gains by subtracting the purchase price from the sale price
        without considering inflation would be inappropriate. As a result, the
        concept of indexing the purchase price has been introduced. The indexed
        purchase price is subtracted from the sale price to calculate gains. As
        a result, indexation only applies to long-term investments.
      </p>
    ),
  },
  {
    header:
      'Should an NRI pay taxes on gains made on selling property in India?',
    content: (
      <p>
        Property sold in India is often tax deductible. If the property is a
        short-term asset, the buyer must deduct taxes at the rate relevant to
        the NRI&apos;s income bracket. If the property is a long-term asset, an
        LTCG tax of 20% is levied. Furthermore, the NRI must ensure that taxes
        are deducted on the gains made rather than the sale money. A
        jurisdictional Assessing Officer can assist in determining which gains
        should be taxed by the purchaser.
      </p>
    ),
  },
  {
    header: 'For how many years can you carry forward capital losses for?',
    content: (
      <p>
        If you could not set off your capital loss in the same year, both
        short-term and long-term losses can be carried forward for 8 assessment
        years immediately following the specific assessment year in which the
        loss was computed.
      </p>
    ),
  },
  {
    header: 'What are the differences between ESOPs and RSUs?',
    content: (
      <p>
        Here are the differences between ESOPs and RSUs:
        <table>
          <tr>
            <th>Basis</th>
            <th>Employee Stock Option Plan</th>
            <th>Restricted Stock Units</th>
          </tr>
          <tr>
            <td>
              <strong>Choice to receive the incentive</strong>
            </td>
            <td>Employees can choose whether or not to buy the shares.</td>
            <td>
              Employees receive these shares at the end of the vesting period.
            </td>
          </tr>
          <tr>
            <td>
              <strong>Market price</strong>
            </td>
            <td>
              Market price plays a big role in an employee&apos;s decision.
            </td>
            <td>Market price only matters for taxation.</td>
          </tr>
          <tr>
            <td>
              <strong>Payment by employees</strong>
            </td>
            <td>Employees need to pay to acquire the underlying shares.</td>
            <td>Employees get them free of cost from the company.</td>
          </tr>
          <tr>
            <td>
              <strong>Type of companies</strong>
            </td>
            <td>
              These are popular with start-ups and high-growth companies in
              their early stage.
            </td>
            <td>
              These are popular with old companies which are well-established.
            </td>
          </tr>
        </table>
      </p>
    ),
  },
  {
    header: `How are ESOPs taxed?`,
    content: (
      <p>
        <p>
          {' '}
          Tax is levied at two points in ESOPs. First, at the time of the
          exercise of the ESOP. Second, at the time of selling the shares.
          Exercise of ESOP is taxed under the head ‘Salary’ (perquisite) where
          the difference between the fair market value of the shares and the
          exercise price of shares is taxed as per the normal tax slab of the
          employee. The sale of shares is further subject to tax under the head
          ‘Capital Gains’, where the difference between the sales price and the
          exercise price is taxed at capital gain (short- or long-term) rates.
        </p>
        <p>
          Read in detail here:{' '}
          <a href="https://cleartax.in/s/esop ">https://cleartax.in/s/esop </a>
        </p>
      </p>
    ),
  },
  {
    header: 'How are RSUs taxed?',
    content: (
      <p>
        <p>
          RSU taxation in India is the same as any other equity share. For the
          purpose of taxation, you need to take into consideration the fair
          market value of the reserved stock units. Fair market value is the
          price at which these shares are sold on the stock market on the
          vesting date. The tax on RSU is calculated both on vesting and when
          the employee sells his/her holdings.
        </p>
        <p>
          Read in detail here:{' '}
          <a href="https://cleartax.in/s/rsu-restricted-stock-unit ">
            https://cleartax.in/s/rsu-restricted-stock-unit
          </a>
        </p>
      </p>
    ),
  },
  {
    header: 'How is cryptocurrency taxed in India?',
    content: (
      <p>
        Gains made from trading cryptocurrencies are taxed at 30% (plus 4% cess)
        according to Section 115BBH. Section 194S levies a 1% Tax Deducted at
        Source (TDS) on the transfer of crypto assets if the transactions exceed
        Rs 50,000 (or even Rs 10,000 in some cases) in the same financial year.
      </p>
    ),
  },
  {
    header: 'Will I be taxed if I receive crypto assets as gifts?',
    content: (
      <p>
        The value of the crypto at the time of gifting will be considered as
        sale value, and the notional gains will be taxed at 30%
      </p>
    ),
  },
  {
    header:
      'I received payments in the form of crypto. What is the tax implication?',
    content: (
      <p>
        Tax is calculated as 30% on the value of the crypto at the time of
        receipt and 30% on the gains made when sold. For example, if you
        received 1 ETH worth Rs.1 lakh as payment for services and you sold it
        at a price of Rs.1.5 lakh, you will have to pay 30% of Rs.1 lakh plus
        30% on Rs.50,000 (gains made) as the total tax due.
      </p>
    ),
  },
];
